import React, { useState } from 'react';
import { getToken, initPayment, confirmPayment } from './Operators/rakakash';
import PrimaryButton from '../Buttons/PrimaryButton';

const Step6 = ({ firstVehicle = {
    "cylindree": "",
    "usage": "taxi",
    "duration": "90",
    "immat": "IMMAT1",
    "vehicleType": "voiture",
    "fiscalPower": "",
    "isInSale": "",
    "numberOfCards": "",
    "cards": "",
    "isDoublePedal": "",
    "seats": "",
    "tonnage": "",
    "realseats": "",
    "trailers": "",
    "brand": "ABARTH",
    "carColor": "Bleu",
    "model": "124 GT",
    "chassisNumber": "EF2 6TYG3F 26835177",
    "manufactureYear": "2020",
    "firstRegistrationYear": "2021",
    "payload": "5",
    "otherspecial": "",
    "lastName": "Declier",
    "firstName": "Pierre",
    "street": "12 rue de la riviere",
    "city": "Paris",
    "country": "France",
    "countryCode": "+93",
    "phoneNumber": "999061084",
    "secondaryCountryCode": "+93",
    "secondaryPhoneNumber": "999061084",
    "email": "clovis.bourgeois@yopmail.com",
    "startDate": "2010-10-10",
    "category": "cat1"
}, operators = ['RakkaCash'], onOtpSubmit, onBack }) => {
    const [selectedOperator, setSelectedOperator] = useState(null);
    const [otpCode, setOtpCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isOtpValid, setIsOtpValid] = useState(false);
    const [token, setToken] = useState(null);
    const formatedNumber = `${firstVehicle.countryCode}${firstVehicle.phoneNumber}`

    const handleOperatorSelect = async (operator) => {
        setSelectedOperator(operator);
        setOtpCode('');
        setErrorMessage('');

        if (operator === 'Rakakash') {
            try {
                const obtainedToken = await getToken();
                setToken(obtainedToken);
                await sendOtp(obtainedToken, formatedNumber); // Envoi du code OTP au numéro
            } catch (error) {
                setErrorMessage("Erreur lors de l'envoi du code OTP.");
            }
        }
    };

    const sendOtp = async (token, phoneNumber) => {
        try {
            await initPayment(token, phoneNumber);
        } catch (error) {
            setErrorMessage("Erreur lors de l'initialisation du paiement.");
        }
    };

    const handleOtpChange = (e) => {
        setOtpCode(e.target.value);
    };

    const verifyOtp = async () => {
        try {
            const response = await confirmPayment(token, otpCode);
            if (response.success) {
                setIsOtpValid(true);
                onOtpSubmit(true);
            } else {
                setIsOtpValid(false);
                setErrorMessage("Le code OTP est incorrect. Veuillez réessayer.");
            }
        } catch (error) {
            setErrorMessage("Erreur de connexion. Veuillez réessayer plus tard.");
        }
    };

    return (
        <div className="step-6">
            <h2 className="text-lg font-bold mb-4">Choisissez votre opérateur</h2>
            <div className="flex flex-wrap gap-x-[20px]">
                {operators.map((operator, index) => (
                    <button
                        key={index}
                        onClick={() => handleOperatorSelect(operator)}
                        className={`p-[10px] bg-gray-100 border rounded-xl ${selectedOperator === operator ? 'selected' : ''}`}>
                        {operator}
                    </button>
                ))}
            </div>

            {selectedOperator && (
                <div className="otp-section mt-4">
                    <h3 className="text-md font-semibold">Entrez le code OTP pour {selectedOperator}</h3>
                    <input
                        type="text"
                        value={otpCode}
                        onChange={handleOtpChange}
                        placeholder="Code OTP"
                        className="otp-input mt-2 p-2 border rounded"
                    />
                    <button
                        onClick={verifyOtp}
                        className="submit-button mt-2 bg-blue-500 text-white py-2 px-4 rounded">
                        Valider
                    </button>

                    {errorMessage && <p className="error-message text-red-500 mt-2">{errorMessage}</p>}
                    {isOtpValid && <p className="success-message text-green-500 mt-2">Code OTP validé avec succès !</p>}
                </div>
            )}
            <PrimaryButton type='button' onClick={onBack} label={"Retour"} className="bg-gray-300 py-2 px-4 rounded mr-2" />
        </div>
    );
};

export default Step6;
